// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H9yq","textarea":"styles_textarea__30onX"};